import React from 'react';
import { Box, Container, Typography, Stack, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const LegalPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to right, #01115C 0%, #01115C 30.085%, #001F5F 60.17%, #001F5F 80.085%, #0A4B8F 100%)',
        color: 'white',
        py: 4
      }}
    >
      <Container maxWidth="lg">
        <Link
          onClick={() => navigate("-1")}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            color: 'primary.main',
            cursor: 'pointer',
            textDecoration: 'none',
            mb: 4,
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          <ArrowBackIcon /> Retour
        </Link>

        <Stack spacing={4} sx={{ maxWidth: '800px', mx: 'auto' }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Mentions légales
          </Typography>

          <Box>
            <Typography variant="body1" paragraph>
              Conformément à la loi n°2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, 
              nous vous informons que : Le présent site a fait l'objet d'une déclaration à la Commission 
              Nationale de l'Informatique et des Libertés – CNIL, en application de la loi n° 2004-801 
              du 6 août 2004 relative à la protection des personnes physiques à l'égard du traitement 
              des données à caractère personnel modifiant la loi n°78-17 du 6 janvier 1978 relative à 
              l'informatique, aux fichiers et aux libertés, modifiée, et est hébergé sur les serveurs d'OVH.
            </Typography>

            <Typography variant="body1" paragraph>
              Les mentions légales pouvant être modifiées à tout moment et sans préavis, nous vous 
              engageons à les consulter régulièrement.
            </Typography>

            <Typography variant="body1" paragraph>
              Dernière mise à jour : 29 mai 2023.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h5" gutterBottom>
              Crédits
            </Typography>
            <Stack spacing={2}>
              <Typography variant="body1">Football Coachs SAS au Capital de 1000 €</Typography>
              <Typography variant="body1">921 381 976 R.C.S. Chambéry</Typography>
              <Typography variant="body1">N° TVA intracommunautaire : FR87921381976</Typography>
              <Typography variant="body1">
                Siège social : 19 boulevard de la mer Caspienne, 73370 Le Bourget du Lac.
              </Typography>
              <Typography variant="body1">Tél : +33(0)6 52 68 23 50</Typography>
              <Typography variant="body1">Email : contact@footballcoachs.com</Typography>
              <Typography variant="body1">Directeur : Jean Paul Igranaissi</Typography>
            </Stack>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default LegalPage;
